import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Cars24Platinum from "./images/warranty.png";
import { NUMBER } from "../../../constants/app-constants";

const Cars24PlatinumCoverCdpBannerRevamp = ({ plans = [] }) => {

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftWrapper"}>
                {((plans.length >= NUMBER.FOUR) || (plans.length >= NUMBER.ONE && plans.length <= NUMBER.THREE)) && (<p styleName={"styles.heading"}>CARS24<br />Platinum cover</p>)}
                {plans.length === NUMBER.ZERO && (<p styleName={"styles.heading"}>Warranty</p>)}
                {(plans.length >= NUMBER.FOUR) && <p styleName={"styles.subHeading"}>3 years of extended<br />warranty to protect your car.</p>}
                {(plans.length === NUMBER.ZERO) && <p styleName={"styles.subHeading"}>This car comes with manufacturer covered warranty.</p>}
                {(plans.length >= NUMBER.ONE && plans.length <= NUMBER.THREE) && <p styleName={"styles.subHeading"}>Extend your warranty with platinum cover.</p>}
            </div>
            <div styleName={"styles.rightWrapper"}>
                <img src={Cars24Platinum} alt="CARS24 Platinum cover" />
            </div>
        </div>
    );
};

Cars24PlatinumCoverCdpBannerRevamp.propTypes = {
    plans: PropTypes.array
};

export default Cars24PlatinumCoverCdpBannerRevamp;
